export default __webpack_public_path__ + "static/media/mallory_compact_thin.73320cc0.ttf";